var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    style: ({
      display: _vm.display
    })
  }, [(_vm.$slots.default) ? _c('span', {
    staticClass: "icon-text"
  }, [(_vm.tooltip) ? _c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": _vm.tooltip,
      "placement": "top"
    }
  }, [_c('i', {
    staticClass: "mr-5",
    class: [_vm.iconClass, 'pointer']
  })]) : _c('i', {
    staticClass: "mr-5",
    class: _vm.iconClass
  }), _vm._v(" "), _vm._t("default")], 2) : _vm._e()])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36259975"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pIcon.vue
// module id = null
// module chunks = 